import React, { useRef, useEffect, useState, useMemo } from 'react';
import { Editor as TinyMCEEditor } from '@tinymce/tinymce-react';
import { getTinyMCEConfig, injectTinyMCEStyles } from '../../../../common/utils/tinymceConfig';

const Editor = (props) => {
  const { content, setContent, mode, recaptchaVerify, placeholder } = props;
  const editorRef = useRef(null);
  const isInitialMount = useRef(true);
  const [editorHeight, setEditorHeight] = useState(600);

  useEffect(() => {
    if (mode === 'modify' && content && editorRef.current && isInitialMount.current) {
      editorRef.current.setContent(content);
      isInitialMount.current = false;
    }
  }, [mode, content]);

  useEffect(() => {
    injectTinyMCEStyles()

    const calculateHeight = () => {
      const windowHeight = window.innerHeight
      const headerHeight = 175
      const newHeight = Math.max(400, windowHeight - headerHeight)
      setEditorHeight(newHeight)
    }

    calculateHeight()
    window.addEventListener('resize', calculateHeight)

    return () => window.removeEventListener('resize', calculateHeight)
  }, [])

  const handleEditorChange = (newContent, editor) => {
    const cleanedContent = removePendingImages(newContent);
    setContent(cleanedContent);
  };

  const handleInit = (evt, editor) => {
    editorRef.current = editor;

    if (mode === 'modify' && content) {
      editor.setContent(content);
    }
  };

  function removePendingImages(html) {
    const wrapper = document.createElement('div');
    wrapper.innerHTML = html;

    const images = wrapper.querySelectorAll('img');
    images.forEach((img) => {
      const src = img.getAttribute('src') || '';

      if (!src || src.startsWith('data:') || src.includes('base64')) {
        const figure = img.closest('figure');
        if (figure) {
          figure.remove();
        } else {
          img.remove();
        }
      }
    });

    return wrapper.innerHTML;
  }

  const tinymceConfig = useMemo(() => getTinyMCEConfig(recaptchaVerify), [recaptchaVerify])

  const initConfig = useMemo(
    () => ({
      ...tinymceConfig,
      min_height: 600, // Fixed height to prevent re-init
      placeholder: placeholder || '내용을 입력하세요.',
      setup: (editor) => {
        if (tinymceConfig.setup) {
          tinymceConfig.setup(editor)
        }

        editor.on('change keyup SetContent', () => {
          editor.save()
        })
      },
    }),
    [tinymceConfig, placeholder]
  )

  // Update height after init
  useEffect(() => {
    if (editorRef.current) {
      const currentHeight = editorRef.current.getContainer()?.offsetHeight || editorHeight
      if (currentHeight < editorHeight) {
        editorRef.current.theme.resizeTo(null, editorHeight)
      }
    }
  }, [editorHeight])

  return (
    <div style={{ minHeight: `${editorHeight}px` }}>
      <TinyMCEEditor
        tinymceScriptSrc='/tinymce-8.1.2/js/tinymce/tinymce.min.js'
        onInit={handleInit}
        value={content}
        onEditorChange={handleEditorChange}
        init={initConfig}
      />
    </div>
  )
}

export { Editor };